// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uqBQ","right":"styles_right__1XUAo"};